import { Injectable } from '@angular/core';
import { StoreBase } from '@stores/abstract';
import { Faq } from '@stores/models';

@Injectable({ providedIn: 'root' })
export class FaqStore extends StoreBase<Faq> {
  override storeName = 'FaqStore';
}
